module.exports = __webpack_public_path__ + "img/11.2d3974f9.jpg";